/**
 * Campo de formulário reutilizável (label + conteúdo).
 * Mantém acessibilidade e estilo consistente no painel de IA.
 */
export default function FormField({ label, id, children }) {
  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={id}
          className="text-[10px] font-black text-appTextMuted uppercase tracking-widest block ml-1"
        >
          {label}
        </label>
      )}
      {children}
    </div>
  );
}
